import axios from "axios";

export const baseUrl = `${process.env.REACT_APP_URL_BASE}`;

async function loginExistsInEvent(eventId, loginId) {
  const config = {
    method: "get",

    url: `${baseUrl}/login-event/${eventId}/event/${loginId}/login`,
    headers: {
      "Content-Type": "application/json",
    },
  };

  return axios(config)
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return error.response.data;
    });
}

export { loginExistsInEvent };
